import styled from 'styled-components';

export const ModalWrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding-top: 0;

  position: relative;

  width: 475px;

  box-sizing: border-box;

  /* Brand Colors/Azul Riva */

  background: ${(props) => props.tema.primaryColor};
  border-radius: 8px;

  /* Inside auto layout */

  flex: none;
  order: 0;
  align-self: stretch;
  flex-grow: 0;
  margin: auto;

  img {
    width: 100%;
    max-height: 400px;
  }

  transition: 0.3s;

  max-height: 98vh;

  @media (max-width: 768px) {
    max-width: 95vw;
    max-height: 98vh;
  }
`;

export const HeaderWrapper = styled.div`
  position: absolute;
  top: 0;
  right: 0;
`;

export const InfoWrapper = styled.div`
  padding: 16px;
`;

export const TitleWrapper = styled.div`
  font-size: 40px;
  text-align: center;
  color: #fff;
  font-weight: 700;
  letter-spacing: -0.02em;
  line-height: 40px;

  @media (max-width: 768px) {
    font-size: 32px;
  }
`;

export const BodyWrapper = styled.div`
  overflow: auto;
  margin-top: 0;

  &::-webkit-scrollbar-track {
    -webkit-box-shadow: transparent;

    background-color: transparent;
    opacity: 0.7;
    margin-top: 32px;
    margin-bottom: 24px;
  }

  &::-webkit-scrollbar {
    width: 12px;
    background-color: transparent;
    opacity: 0.7;
  }

  &::-webkit-scrollbar-thumb {
    -webkit-box-shadow: transparent;
    background-color: transparent;
    opacity: 0.5;
    border-left: 6px #f1f1f1 solid;
  }
`;

export const ParagraphWrapper = styled.p`
  color: #f6f6f6;
  font-weight: 400;
  font-size: 16px;
  text-align: center;
  line-height: 24px;
`;
